import type { Lead } from '../types';

/**
 * Status no Kanban de vendas onde o lead pode estar em modo IA com orquestração ativa
 * (badge, spinner, handoff «Humano», ações Assumir/Parar).
 */
export const LEAD_IA_ORCHESTRATION_KANBAN_STATUSES: ReadonlyArray<Lead['status']> = [
  'em_atendimento',
  'em_negociacao',
  'proposta',
  'urgente',
];

export function isLeadIaOrchestrationKanbanStatus(status: Lead['status']): boolean {
  return LEAD_IA_ORCHESTRATION_KANBAN_STATUSES.includes(status);
}
